import classNames from 'classnames'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import { toast } from 'react-toastify'
import { ReactComponent as TrashIcon } from 'svg/trash.svg'
interface SecondProps {
  file: File | null
  setFile: Dispatch<SetStateAction<File | null>>
  setErrorModalOpen: Dispatch<SetStateAction<boolean>>
  setErrorTitle: Dispatch<SetStateAction<JSX.Element>>
  setErrorSubTitle: Dispatch<SetStateAction<JSX.Element>>
}

export const ThirdStep = ({
  file,
  setFile,
  setErrorModalOpen,
  setErrorTitle,
  setErrorSubTitle,
}: PropsWithChildren<SecondProps>) => {
  const [fileName, setFileName] = useState<string>('')

  const handleDeleteFile = () => {
    setFileName('')
    setFile(null)

    const fileInput = document.getElementById('file-input') as HTMLInputElement
    if (fileInput) fileInput.value = ''
  }
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files) return

    const MAX_FILE_SIZE_MB = 20
    const selectedFiles = Array.from(event.target.files)
    const originalFile = selectedFiles[0]

    const fileSizeMB = originalFile.size / (1024 * 1024)

    if (fileSizeMB > MAX_FILE_SIZE_MB) {
      setErrorTitle(<p>🚨 파일 용량 초과</p>)
      setErrorSubTitle(
        <p>
          20MB 미만의 파일을
          <br />
          업로드 해주세요
        </p>
      )

      setErrorModalOpen(true)
      return
    }
    const reader = new FileReader()
    reader.onload = async () => {
      const arrayBuffer = reader.result as ArrayBuffer

      const audioContext = new AudioContext()
      try {
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
        const durationInSeconds = audioBuffer.duration
        console.log(`오디오 길이: ${durationInSeconds.toFixed(2)}초`)

        // 오디오 길이 조건 확인 (10초 미만 or 5분 초과)
        if (durationInSeconds < 10 || durationInSeconds > 300) {
          setErrorTitle(<p>🚨 녹음 파일을 확인해주세요!</p>)

          setErrorSubTitle(
            <>
              <p className="text-error mb-10">
                10초 이상 5분 이하의 파일만 가능합니다.
              </p>
              <p>
                내 목소리 생성 기준
                <br />
                <span className="text-main font-bold">
                  최소 10초 ~ 최대 5분
                </span>
              </p>
            </>
          )
          event.target.value = ''
          setErrorModalOpen(true)
          return
        }

        setFile(originalFile)
        setFileName(originalFile.name)
      } catch (error) {
        console.error('오디오 디코딩 실패:', error)

        setErrorTitle(<p>🚨 파일을 분석할 수 없습니다</p>)
        setErrorSubTitle(
          <p>지원되지 않는 오디오 형식이거나 손상된 파일일 수 있습니다.</p>
        )
        setErrorModalOpen(true)
      } finally {
        event.target.value = ''
      }
    }

    reader.readAsArrayBuffer(originalFile)
  }
  return (
    <div className="text-center space-y-4 md:h-[450px]">
      <ul
        className=" list-disc px-4 py-8 
       text-left bg-[#F6F8FB]  h-[290px] overflow-auto rounded-[10px]"
      >
        <p className="font-bold text-[18px] mb-4">
          🗣️ 아래 10개의 문장을 명확한 발음과 억양으로 잘 읽어서 녹음한 파일을
          업로드 해주세요!
        </p>
        <li className="ml-4 mb-2">
          ‘패스트컷 내 목소리'는, 내 목소리를 녹음하여 내 목소리를 닮은 TTS
          음성을 만드는 서비스입니다.
        </li>
        <li className="ml-4 mb-2">
          이 목소리는 녹음자 본인의 목소리이며, 녹음한 음성을 TTS 생성 목적으로
          사용하는 데 동의합니다.
        </li>
        <li className="ml-4 mb-2">
          이걸 나만 모르고 있었네. 컬러풀한 5가지 색상 커피 텀블러가 있다고 해서
          바로 가져와봤음.
        </li>
        <li className="ml-4 mb-2">
          아니 웬걸. 최고의 시청 경험을 선사하는 제품이 있다고 해서 리뷰를 해
          봤구요. 선명한 화질과 풍부한 색감이 탁월하구요.
        </li>

        <li className="ml-4 mb-2">
          뛰어난 성능과 세련된 디자인을 자랑하는 희대의 아이템을 가져왔다. 장점
          중심으로 빠르게 간다. 무조건 사야 된다!
        </li>
        <li className="ml-4 mb-2">
          와 하루 종일 지속되는 강력한 배터리가 있다고? 오늘의 한줄평 이거 완전
          필수템!
        </li>
        <li className="ml-4 mb-2">
          어 이 제품 뭐지? 인체공학적 디자인으로 진짜 편안해요. 이거는 진짜
          괜찮은데요? 바로 추천 갑니다!
        </li>
        <li className="ml-4 mb-2">
          퇴근 후에 피곤한 나를 도와줄 로봇 청소기! 오늘도 만족을 주니 이
          아이템도 5점 줄게요!
        </li>
        <li className="ml-4 mb-2">
          내가 에센스를 찾고 있었는데 이걸 발견했지 뭐야? 피부 깊숙이 스며드는
          영양감으로 기능성 끝판왕이더라고. 나는 다음에도 또 사고 싶으니 추천!
        </li>
        <li className="ml-4 mb-2">
          이거 한 번 써보세요. 사길 정말 잘했어요. 요리를 쉽고 빠르게 만들 수
          있는 스마트 조리 기구. 정말 만족해요!
        </li>
      </ul>

      <div className="flex flex-col gap-2 ">
        <div
          className={classNames('', {
            'flex items-center gap-2': !isMobile,
            'flex flex-col gap-2': isMobile,
          })}
        >
          <div className="flex items-center gap-2 ">
            <button
              onClick={(event) => {
                event.preventDefault() // 기본 form 제출 동작을 방지
                document.getElementById(`file-input`)?.click() // 파일 선택 창 열기
              }}
              type="button"
              className="flex items-center justify-center w-[122px] h-[36px] text-white rounded-full bg-[#6B8ACB] text-[14px] font-bold mb-1 "
            >
              <img
                src="assets/img/icon_image.png"
                alt=""
                width={17}
                className="mr-[6px]"
              />
              <span>파일 업로드</span>
            </button>
            <input
              id="file-input"
              onChange={handleFileChange}
              type="file"
              accept=".m4a,.wav, .mp3"
              className="hidden"
            />
            <p className="text-[#8F929B] text-[14px]  text-left  ">
              최소 1분 ~ 최대 5분 | 20MB 이하 | MP3, M4A, WAV
            </p>
          </div>
          {fileName && (
            <p className="bg-[#F6F8FB] px-4 py-2 rounded-[4px] text-[14px] text-right flex-1   flex items-center justify-end gap-2">
              <span>{fileName}</span>{' '}
              <button onClick={handleDeleteFile}>
                <TrashIcon />
              </button>
            </p>
          )}
        </div>
        <p className="text-error text-[14px] text-left">
          최대한 조용한 곳에서 위 문장을 잘 읽어서 녹음해주세요! <br />
          녹음 파일의 질에 따라 목소리가 생성되지 않거나 품질이 떨어질 수
          있으며, 무료 재생성은 불가능합니다.{' '}
        </p>
      </div>
    </div>
  )
}
